/**
 * True while any lane modal is open. Every lane modal (claim/member pickers,
 * archive reason, forward composer, create/import/export dialogs, the
 * ring-fence confirms) renders `.lane-modal-backdrop`, including the ones
 * TaskDetailPane owns internally, which a lane's own state can't see.
 * `[aria-modal="true"]` catches anything else built as a real modal.
 *
 * Wrong-claim attach guard (2026-09-28): the lender lane's j/k triage used
 * to move the selection behind an open assign modal whenever focus sat on
 * a button (the input/select check didn't cover that).
 */
export function isLaneModalOpen(doc: Document = document): boolean {
  return !!doc.querySelector('.lane-modal-backdrop, [aria-modal="true"]');
}
